// Conta quantos filtros estão ativos num objeto de filtros aplicados e monta o
// label do botão ("Filtro" / "Filtro (2)"). Como cada rotina guarda os filtros
// num shape próprio (arrays, boolean|null, strings, faixas de data), a contagem
// é genérica: array não-vazio = 1, boolean setado (!== null) = 1, string/number
// preenchido = 1, e um par de datas conta como 1 quando ambas as pontas existem.

type CountFiltrosOpts = {
  // chaves que não devem entrar na contagem (ex.: a busca livre da toolbar).
  ignore?: string[];
  // pares [inicio, fim] tratados como um único filtro quando ambos preenchidos.
  dateRanges?: Array<[string, string]>;
};

const preenchido = (v: unknown): boolean =>
  v !== null && v !== undefined && v !== '' && !(Array.isArray(v) && v.length === 0);

export function countFiltros(obj: object | null | undefined, opts: CountFiltrosOpts = {}): number {
  if (!obj) return 0;
  const rec = obj as Record<string, unknown>;
  const ignore = new Set(opts.ignore ?? []);
  const dateRanges = opts.dateRanges ?? [];
  const rangeKeys = new Set(dateRanges.flat());

  let total = 0;
  for (const [inicio, fim] of dateRanges) {
    if (preenchido(rec[inicio]) && preenchido(rec[fim])) total += 1;
  }
  for (const [chave, valor] of Object.entries(rec)) {
    if (ignore.has(chave) || rangeKeys.has(chave)) continue;
    if (Array.isArray(valor)) {
      if (valor.length > 0) total += 1;
    } else if (typeof valor === 'boolean') {
      total += 1; // toggle setado (null cai no ramo de baixo e não conta)
    } else if (preenchido(valor)) {
      total += 1;
    }
  }
  return total;
}

/** "Filtro" quando n = 0, "Filtro (n)" quando n > 0. */
export function labelFiltro(base: string, n: number): string {
  return n > 0 ? `${base} (${n})` : base;
}

// Evento de "interação fora" do Radix (onInteractOutside/onPointerDownOutside):
// é um CustomEvent cujo alvo real vem em detail.originalEvent.target.
type InteracaoFora = {
  detail?: { originalEvent?: Event };
  target?: EventTarget | null;
  preventDefault(): void;
};

// Selectores dos elementos que o AgnesSelect renderiza num portal (fora da DOM do
// popover): a lista de opções e o trigger. data-slot vem do próprio DS.
const SELECT_PORTAL = '[data-slot="select-content"],[data-slot="select-trigger"],[role="listbox"]';

// O AgnesSelect renderiza suas opções num SelectPrimitive.Portal (document.body),
// fora da DOM do popover de filtro. Sem tratamento, o dismissable layer do Radix
// enxerga o clique na opção como clique "fora" e fecha o popover inteiro. Este
// handler barra o fechamento quando a interação parte do portal do select,
// preservando o fechamento por clique realmente fora e pelo botão X.
export function protegerSelectDoFechamento(event: InteracaoFora): void {
  const alvo = (event.detail?.originalEvent?.target ?? event.target) as HTMLElement | null;
  if (alvo?.closest?.(SELECT_PORTAL)) {
    event.preventDefault();
  }
}
